module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAZBAMAAACiITGiAAAAD1BMVEUAAAD///////////////+PQt5oAAAABHRSTlMA+oXzaYBfNAAAABpJREFUGNNjUHRBAUIMIqgCzpgqBgsYUU4HAKChI7D4/AtaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-tab.png
// module id = i9Ot
// module chunks = 1